import React from 'react'
import BuyerProfile from './Partial/BuyerProfile'
import Menubar from './Partial/Menubar'

export default function Profile() {

    return (
        <>
            <Menubar title="Profile Page" />
            <BuyerProfile title="" />
        </>
    )
}
